import { Box } from '@mui/material';
import { LAYOUT, PAGE_TOP, SECTION_Y } from '../../theme/tokens';

// ---------------------------------------------------------------------------
// Banda orizontală din care e făcută fiecare pagină.
//
// Înainte, fiecare pagină își scria singură fundalul, lățimea coloanei și
// padding-ul de sus, cu altă valoare peste tot — de acolo veneau distanțele
// inegale față de bara de meniu și coloanele de lățimi diferite de la o pagină
// la alta. Acum există un singur loc.
//
//   tone="page"   fundalul de bază
//   tone="alt"    treapta de gri, pentru secțiunea următoare
//   tone="deep"   panoul bleumarin, cu text alb
//   first         rezervă distanța până sub bara fixă (`--page-top`)
// ---------------------------------------------------------------------------

const TONES = {
  page: {
    backgroundColor: 'var(--qf-bg)',
    color: 'var(--qf-ink)',
  },
  alt: {
    backgroundColor: 'var(--qf-bg-alt)',
    color: 'var(--qf-ink)',
  },
  // Lumină statică, nu gradient animat: un gradient de 400% care se mișcă la
  // infinit repictează tot ecranul la fiecare cadru și ține radioul GPU pornit
  // degeaba pe telefon.
  deep: {
    backgroundColor: 'var(--qf-deep)',
    color: 'var(--qf-deep-ink)',
    backgroundImage: `radial-gradient(1200px 680px at 12% -20%, rgba(76,157,255,.30), transparent 62%),
                      radial-gradient(900px 560px at 96% 112%, rgba(10,108,241,.26), transparent 66%)`,
  },
};

export default function Section({
  children,
  tone = 'page',
  first = false,
  py = SECTION_Y,
  maxWidth = LAYOUT.maxWidth,
  component = 'section',
  id,
  sx,
  innerSx,
  ...rest
}) {
  return (
    <Box
      component={component}
      id={id}
      sx={{
        position: 'relative',
        isolation: 'isolate',
        ...TONES[tone],
        pt: first ? PAGE_TOP : py,
        pb: py,
        ...sx,
      }}
      {...rest}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth,
          mx: 'auto',
          paddingInline: LAYOUT.gutter,
          ...innerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
